/* eslint-disable @typescript-eslint/no-explicit-any */
export default function Subheading(props: { children: any }) {
  return (
    <p className='text-black text-base lg:text-lg font-medium tracking-wider mb-4'>
      {props.children}
    </p>
  )
}
